import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import camelize from 'camelize';
import {
  INIT_APP,
  GET_ME_FAILED,
  GET_ME_REQUESTED,
  getMe as mkGetMe,
  initApp as mkInitApp,
  GET_USER_REFRESH_REQUESTED,
  GET_USER_REFRESH_SUCCEEDED,
  GET_USER_REFRESH_FAILED,
  GET_ME_SUCCEEDED,
  GET_CURRICULUMS,
  GET_CURRICULUMS_SUCCEEDED,
  GET_CURRICULUMS_FAILED,
  GET_GRADES,
  GET_GRADES_SUCCEEDED,
  GET_GRADES_FAILED,
  GET_GRADE_DETAILS,
  GET_GRADE_DETAILS_SUCCEEDED,
  GET_GRADE_DETAILS_FAILED,
  GET_SKILL_CONFIGS,
  GET_SKILL_CONFIGS_SUCCEEDED,
  GET_SKILL_CONFIGS_FAILED,
  SEND_FOR_DOWNLOAD_REQUESTED,
  SEND_FOR_DOWNLOAD_SUCCEEDED,
  SEND_FOR_DOWNLOAD_FAILED,
  GET_TOPIC_CONFIGS,
  GET_CONCEPT_CONFIGS,
  GET_CCFILTRERS,
  GET_CCFILTRERS_SUCCEEDED,
  GET_CCFILTRERS_FAILED,
  GET_CCSubjects,
  GET_CCSubjects_SUCCEEDED,
  GET_CCSubjects_FAILED,
} from "./action";
import API from './api';

import { parseQuestionResponse, b64DecodeUnicode } from './utils';


const JWT_TOKEN = 'cerebry-jwt-token';
const JWT_REFRESH = 'cerebry-jwt-refresh';

const RESET_PAGE = '/reset';
const CONTENT_PAGE = '/content';

const getSavedJWT = (jwtKey) => {
  return Cookies.get(jwtKey);
};

const getPathName = (key) => {
  return location.pathname.indexOf(key) > -1 ? true : false;
};

const saveJWT = (jwtKey, jwtValue) => {
  if (location.hostname === 'localhost') {
    Cookies.set(jwtKey, jwtValue);
  } else {
    Cookies.set(jwtKey, jwtValue, { expires: 30, domain: 'cerebry.co' });
  }
};

function* getMe() {
  try {
    const resp = yield call(API.getMe);
    if (resp.status >= 400) {
      if(resp.status == 401) location.href = "https://teacherdashboard.cerebry.co/login"
      yield put({
        type: GET_ME_FAILED,
        resp: camelize(resp),
      });

    } else {
      yield put({
        type: GET_ME_SUCCEEDED,
        resp: camelize(resp),
      });
    }
  } catch (e) {
    yield put({
      type: GET_ME_FAILED,
    });
  }
}

export function removeJWT(jwtKey) {
  Cookies.remove(jwtKey);
}

function* initApp(dispatch) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const auth_refresh = urlParams.get("auth_refresh");
    const auth_tok = urlParams.get("auth_tok");
    if (!!auth_tok && auth_tok.length > 0) {
      saveJWT(JWT_TOKEN, auth_tok);
    }
    const jwtToken = getSavedJWT(JWT_TOKEN);
    API.setAccessToken('jwt ' + jwtToken);
    console.log(jwtToken);
    yield put(mkGetMe());
  } catch (e) {
    console.log(e.message);
  }
}

function* getUserRefresh() {
  try {
    if (refreshToken && refreshToken.length > 0) {
      API.setAccessToken('jwt ' + refreshToken);
      const resp = yield call(API.refreshUser);
      if (resp.status < 400) {
        yield put({
          type: GET_USER_REFRESH_SUCCEEDED,
          resp: camelize(resp),
        });
        API.setAccessToken('jwt ' + resp.data.jwt);
        yield put(mkInitApp());
      } else {
        yield put({
          type: GET_USER_REFRESH_FAILED,
        });
      }
    } else {
      yield put({
        type: GET_USER_REFRESH_FAILED,
      });
    }
  } catch (e) {
    console.log(e);
    yield put({
      type: GET_USER_REFRESH_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetCurriculums(payload) {
  try {
    const resp = yield call(API.fetchCurriculums, payload);
    if (resp.status < 400) {
      yield put({
        type: GET_CURRICULUMS_SUCCEEDED,
        payload: resp.data
      });
    } else {
      yield put({
        type: GET_CURRICULUMS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_CURRICULUMS_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetGrades(payload) {
  try {
    const resp = yield call(API.fetchGrades, payload);
    if (resp.status < 400) {
      yield put({
        type: GET_GRADES_SUCCEEDED,
        payload: resp.data
      });
    } else {
      yield put({
        type: GET_GRADES_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_GRADES_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetGradeDetails(payload) {
  try {
    const resp = yield call(API.fetchGradeDetails, payload);
    if (resp.status < 400) {
      yield put({
        type: GET_GRADE_DETAILS_SUCCEEDED,
        payload: resp.data
      });
    } else {
      yield put({
        type: GET_GRADE_DETAILS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_GRADE_DETAILS_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetCCFilters() {
  try {
    const resp = yield call(API.fetchCCFilters);
    if (resp.status < 400) {
      yield put({
        type: GET_CCFILTRERS_SUCCEEDED,
        payload: resp.data
      });
    } else {
      yield put({
        type: GET_CCFILTRERS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_CCFILTRERS_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetCCSubjects() {
  try {
    const resp = yield call(API.fetchCCSubjects);
    if (resp.status < 400) {
      yield put({
        type: GET_CCSubjects_SUCCEEDED,
        payload: resp.data
      });
    } else {
      yield put({
        type: GET_CCSubjects_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_CCSubjects_FAILED,
      message: e.message,
    });
  }
}

export function* watchGetSkillConfigs(payload) {
  try {
    const resp = yield call(API.fetchSkillConfigs, payload);
    if (resp.status < 400) {
      let newResult = [...resp.data.results].map(configObj => {
        let newConfigObj = {...configObj}
        if(configObj.question.id) newConfigObj.question_id = configObj.question.id
        if(configObj.question.answer_type) newConfigObj.answer_text = configObj.question.answer_type
        if(configObj.question.question) newConfigObj.question_text = configObj.question.question
        return newConfigObj
      })
      let newData = {...resp.data}
      newData.results = newResult
      yield put({
        type: GET_SKILL_CONFIGS_SUCCEEDED,
        payload: newData
      });
    } else {
      yield put({
        type: GET_SKILL_CONFIGS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_SKILL_CONFIGS_FAILED,
      message: e.message,
    });
  }
}


export function* watchGetTopicConfigs(payload) {
  try {
    const resp = yield call(API.fetchTopicConfigs, payload);
    if (resp.status < 400) {
      let newResult = [...resp.data.results].map(configObj => {
        let newConfigObj = {...configObj}
        if(configObj.question.id) newConfigObj.question_id = configObj.question.id
        if(configObj.question.answer_type) newConfigObj.answer_text = configObj.question.answer_type
        if(configObj.question.question) newConfigObj.question_text = configObj.question.question
        return newConfigObj
      })
      let newData = {...resp.data}
      newData.results = newResult
      yield put({
        type: GET_SKILL_CONFIGS_SUCCEEDED,
        payload: newData,
      });
    } else {
      yield put({
        type: GET_SKILL_CONFIGS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_SKILL_CONFIGS_FAILED,
      message: e.message,
    });
  }
}


export function* watchGetConceptConfigs(payload) {
  try {
    const resp = yield call(API.fetchConceptConfigs, payload);
    if (resp.status < 400) {
      let newResult = [...resp.data.results].map(configObj => {
        let newConfigObj = {...configObj}
        if(configObj.question.id) newConfigObj.question_id = configObj.question.id
        if(configObj.question.answer_type) newConfigObj.answer_text = configObj.question.answer_type
        if(configObj.question.question) newConfigObj.question_text = configObj.question.question
        return newConfigObj
      })
      let newData = {...resp.data}
      newData.results = newResult
      yield put({
        type: GET_SKILL_CONFIGS_SUCCEEDED,
        payload: newData,
      });
    } else {
      yield put({
        type: GET_SKILL_CONFIGS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_SKILL_CONFIGS_FAILED,
      message: e.message,
    });
  }
}


export function* watchSendForDownload(payload) {
  try {
    const queryParameters = new URLSearchParams(window.location.search)
    const redUrl = decodeURIComponent(queryParameters.get("red_url"))
    const classCode = redUrl.split("/")[3]

    const resp = yield call(API.sendDownloadRequest, payload,classCode);
    if (resp.status < 400) {
      yield put({
        type: SEND_FOR_DOWNLOAD_SUCCEEDED,
        payload: resp.data
      });
      if(payload.payload.downloadType=="Online"){
        location.href = redUrl
      }
    } else {
      yield put({
        type: SEND_FOR_DOWNLOAD_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: SEND_FOR_DOWNLOAD_FAILED,
      message: e.message,
    });
  }
}


export default function* rootSaga() {
  yield all([
    takeLatest(INIT_APP, initApp),
    takeLatest(GET_ME_REQUESTED, getMe),
    takeLatest(GET_USER_REFRESH_REQUESTED, getUserRefresh),
    takeLatest(GET_CURRICULUMS, watchGetCurriculums),
    takeLatest(GET_GRADES, watchGetGrades),
    takeLatest(GET_GRADE_DETAILS, watchGetGradeDetails),
    takeLatest(GET_CCFILTRERS, watchGetCCFilters),
    takeLatest(GET_CCSubjects, watchGetCCSubjects),
    takeLatest(GET_SKILL_CONFIGS, watchGetSkillConfigs),
    takeLatest(GET_TOPIC_CONFIGS, watchGetTopicConfigs),
    takeLatest(GET_CONCEPT_CONFIGS, watchGetConceptConfigs),
    takeLatest(SEND_FOR_DOWNLOAD_REQUESTED, watchSendForDownload),
  ]);
}
